// extracted by mini-css-extract-plugin
module.exports = {"page":"Login_page__28OoG","auth":"Login_auth__3pXbN","signinLink":"Login_signinLink__23K7Y","error":"Login_error__3NTU3","success":"Login_success__1fMxz"};